<template>
  <div class="app-container">
    <div class="successDiv">
      <div>
        <van-icon name="checked" color="#07c160" size="33vw" />
      </div>
      <div class="tipText">
        付款成功
      </div>
      <div class="buttons">
        <van-button type="primary" size="large" class="button" to="other-repay">
          继续代缴还款
        </van-button>
        <van-button type="primary" size="large" class="button" to="self-repay">
          继续在线还款
        </van-button>
        <van-button
          plain
          type="primary"
          size="large"
          class="button"
          to="lease-info"
        >
          合同信息查询
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "vant";

export default {
  name: "PaySuccess",
  components: {
    [Icon.name]: Icon
  },
  data() {
    return {
      param: this.$route.query
    };
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.app-container {
  width: 100%;
  height: 100%;
  background-color: white;
}
.successDiv {
  padding-top: 8vh;
  text-align: center;
}
.tipText {
  margin: 6vh 0;
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;
}
.buttons {
  margin: 0 8%;
}
.button {
  margin-bottom: 4vh;
}
</style>
